import { Link } from "react-router-dom";
import { StudentPackage } from "@/services/admin/common.interfaces";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AdminPurchasedPackageCardProps {
  pkg: StudentPackage;
  onRemove: (pkg: StudentPackage) => void;
  /** When provided, a "Ver módulos" link is shown to open package management for this student. */
  studentId?: string;
  className?: string;
}

export const AdminPurchasedPackageCard = ({
  pkg,
  onRemove,
  studentId,
  className
}: AdminPurchasedPackageCardProps) => {
  return (
    <div className={cn("rounded-lg border bg-white p-4 shadow", className)}>
      <div className="flex flex-col space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">{pkg.name}</h3>
          <div className="flex items-center gap-2">
            {studentId && (
              <Link to={`/admin/access/students/${studentId}/packages/${pkg.id}`}>
                <Button variant="outline" size="sm" className="text-blue-600 hover:bg-blue-50">
                  <i className="fa-solid fa-list mr-1"></i>
                  Ver módulos
                </Button>
              </Link>
            )}
            <Button
              variant="ghost"
              size="sm"
              className="text-red-600 hover:text-red-700 hover:bg-red-50"
              onClick={() => onRemove(pkg)}
            >
              <i className="fa-solid fa-trash"></i>
            </Button>
          </div>
        </div>
        <div className="space-y-2">
          <p className="text-sm text-neutral-600">{pkg.description}</p>
          <div className="pt-2 border-t">
            <h4 className="text-sm font-medium mb-1">Package Details</h4>
            <ul className="text-sm text-neutral-600 space-y-1">
              <li className="flex items-center justify-between">
                <span>Purchase Date</span>
                <span>{new Date(pkg.purchaseDate).toLocaleDateString()}</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Progresso Geral</span>
                <span className="font-medium">{pkg.overallProgress}%</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Dias Consecutivos</span>
                <span className="font-medium">{pkg.consecutiveDays}</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Dias sem acesso ao módulo</span>
                <span className="font-medium">{pkg.inactiveDays}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
